import { memo, useState } from "react";
import { Box, Typography } from "@mui/material";
import dayjs from "dayjs";

export const DateFormatCell = ({ item }) => {
  const dateFormat = "DD.MM.YYYY HH:mm";
  const content = dayjs(item).format(dateFormat).split(" ");

  return content.map((e, i) => (
    <Typography key={i} className="table_row_text">
      {e}
    </Typography>
  ));
};

export const SimpleHeader = ({ name }) => (
  <Box className="table-head-up_level">
    <Typography className="standart">{name || ""}</Typography>
  </Box>
);

export const ArrayNamesCell = memo(({ item }) => {
  const [isExpanded, setIsExpanded] = useState(false);

  if (!item || !Array.isArray(item)) {
    return null;
  }

  const maxVisibleItems = 3;
  const shouldShowToggle = item.length > maxVisibleItems;
  const visibleItems = isExpanded ? item : item.slice(0, maxVisibleItems);

  return (
    <div style={{ display: "flex", flexDirection: "column" }}>
      <div
        style={{
          maxHeight: isExpanded ? "none" : `${maxVisibleItems * (24 + 8) - 2}px`,
          overflow: "hidden",
          display: "flex",
          flexDirection: "column",
          gap: "8px",
        }}
      >
        {visibleItems.map((element, index) => (
          <Typography key={index} className="table_row_text">{`${element}` || ""}</Typography>
        ))}
      </div>

      {shouldShowToggle && (
        <Typography
          onClick={() => setIsExpanded(!isExpanded)}
          sx={{
            alignSelf: "flex-start",
            color: "black",
            cursor: "pointer",
            padding: "4px 0",
            marginTop: "4px",
          }}
        >
          {isExpanded ? "Свернуть" : `Показать все (${item.length})`}
        </Typography>
      )}
    </div>
  );
});

export const SimpleTextCell = ({ item }) => <Typography className="table_row_text">{item || ""}</Typography>;
